import React, { useState, useEffect } from "react";
import { Table, Select, DatePicker, Space, Button, Input, message, Tooltip } from "antd";
import {
  DownloadOutlined,
  ReloadOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { BE_HOST } from "../../config/config";
import { useSelector } from "react-redux";
import moment from "moment";
import dayjs from 'dayjs';
import "./DataTableGpr.css";
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable'; // 👈 Make sure this is the default import
import HeaderCompo from "../../component/Header";
import { axiosInstance } from "../../utils/axiosInterceptor";
import * as XLSX from 'xlsx';
import Chat from "../../components/chats/Chat";
import utc from "dayjs/plugin/utc";
import { MessageCircle } from "lucide-react";

dayjs.extend(utc);
const { RangePicker } = DatePicker;

const DataTableGpr = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 50,
    total: 0,
  });
  const [selectedPharmacies, setSelectedPharmacies] = useState([]);
  const [userAccounts, setUserAccounts] = useState([]);
  const [isDownloading,setDownLoading] = useState(false)
   const SelectedPharmacy = useSelector(state => {
    return state.pharmacyData?.pharmacyData;
  });
  // const [dateRange, setDateRange] = useState([
  //   moment("2024-10-01").startOf("day"),
  //   moment("2024-10-31").endOf("day"),
  // ]);
  const [fullData, setFullData] = useState([]); // All records (unpaginated)
  const [chatBoxOpen, setChatOpen] = useState(false)

  // const [fromDate, setFromDate] = useState(() => {
  //   const now = new Date();
  //   const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0);
  //   return firstOfMonth;
  // });
  // const [toDate, setToDate] = useState(() => {
  //   const today = new Date();
  //   today.setHours(23, 59, 59, 999); // Set to end of today
  //   return today;
  // });
  const [fromDate, setFromDate] = useState(() => {
    const now = new Date();
    return new Date(Date.UTC(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0));
  });

  const [toDate, setToDate] = useState(() => {
    const now = new Date();
    return new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999));
  });

  const token = localStorage.getItem("token");
  // const { token } = useSelector((state) => state.userAuth.token);
  // console.log(decodedToken , 'decodeToken');
  // const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [searchText, setSearchText] = useState("");
  const userInfo = useSelector((state) => state.userAuth.decodedToken.user);
  const [allUserFetched, setAllUserFetched] = useState(false);

  // Update columns with search functionality
  const columns = [
    {
      title: "Trans ID",
      dataIndex: "trans_id",
      key: "trans_id",
      sorter: false,
      filteredValue: [searchText],
      onFilter: (value, record) => {
        return (
          String(record.trans_id).toLowerCase().includes(value.toLowerCase()) ||
          String(record.AccountName)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.NDC).toLowerCase().includes(value.toLowerCase()) || String(record?.AccountNumber).toLowerCase().includes(value.toLowerCase())
        );
      },
    },
    {
      title: "Reporting Period",
      dataIndex: "ReportingPeriod",
      key: "ReportingPeriod",
      sorter: false,
    },
    {
      title: "Account Number",
      dataIndex: "AccountNumber",
      key: "AccountNumber",
      sorter: false,
    },
    {
      title: "Account Name",
      dataIndex: "AccountName",
      key: "AccountName",
      sorter: false,
    },
    { title: "GCN", dataIndex: "GCN", key: "GCN", sorter: false },
    { title: "NDC", dataIndex: "NDC", key: "NDC", sorter: false },
    {
      title: "NDC Description",
      dataIndex: "NDC Description",
      key: "NDC Description",
      sorter: false,
    },
    {
      title: "Purchase Quantity",
      dataIndex: "PurchaseQuantity",
      key: "PurchaseQuantity",
      sorter: false,
      align : "right"
    },
    {
      title: "Purchase Amount",
      dataIndex: "PurchaseAmount",
      key: "PurchaseAmount",
      align : "right",
      sorter: false,
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : `$ ${val?.toFixed(2)}`,
    },
    {
      title: "Dispense Quantity",
      dataIndex: "DispenseQuantity",
      key: "DispenseQuantity",
      align : "right",
      sorter: false,
    },
    {
      title: "Dispense Amount",
      dataIndex: "DispenseAmount",
      key: "DispenseAmount",
      sorter: false,
      align : "right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : `$ ${val?.toFixed(2)}`,
    },
    {
      title: "Estimated Leakage",
      dataIndex: "EstimatedLeakage",
      key: "EstimatedLeakage",
      align : "right",
      sorter: false,
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "GPR Effect %",
      dataIndex: "GPR Effect",
      key: "GPR Effect",
      sorter: true,
      defaultSortOrder: "ascend",
      align : "right",
      render: (val) =>
        val === undefined ||
        val === null ||
        val === "" ||
        val === "null"
          ? "-"
          : `${Number(val)?.toFixed(2)} %`,
      // sortDirections: ['ascend', 'descend']
    },
    {
      title: "Price Type",
      dataIndex: "PriceType",
      key: "PriceType",
      sorter: false,
    },
  ];
  useEffect(() => {
    const fetchUserAccounts = async () => {
      const formattedFromDate = formatDate(fromDate);
      const apiVersion = getApiVersionByDate(formattedFromDate);
      try {
        const response = await axiosInstance.get(
          `/${apiVersion}users/accounts?email=${userInfo?.email}`,
          // {
          //   headers: {
          //     "Content-Type": "application/json",
          //     authorization: `Bearer ${token}`,
          //   },
          // }
        );
        // console.log("response", response.data.data.data);
        setUserAccounts(response.data.data.data);
        setAllUserFetched(true)

      } catch (error) {
        console.error("Error:", error);
      }
    };
    fetchUserAccounts();
  }, []);

  useEffect(() => {
    if (!allUserFetched) return;
    if (userAccounts.length > 0 && selectedPharmacies.length === 0) {
      const specialUser = userAccounts.find(user => user.acct_id === 96167);
      if(SelectedPharmacy?.length > 0){
        setSelectedPharmacies(SelectedPharmacy)
      }else if (specialUser) {
        setSelectedPharmacies([specialUser?.acct_id]);
      } else {
        setSelectedPharmacies([userAccounts[0]?.acct_id]);
      }
    }
  }, [userAccounts, selectedPharmacies, allUserFetched, SelectedPharmacy]);



  const disabledFutureDate = (current) => current && current > moment().endOf("day")

  function formatDate(date) {
  const d = new Date(date);
  const year = d.getUTCFullYear();
  const month = String(d.getUTCMonth() + 1).padStart(2, "0");
  const day = String(d.getUTCDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
const getApiVersionByDate = (date) => {
  if (!date) return "v2"; 
  const sep2025 = new Date("2025-09-01");
  const selectedDate = new Date(date);

  return selectedDate < sep2025 ? "" : "api/v2/";
};

  
  const fetchData = async () => {
    setLoading(true);
    try {
      const formattedFromDate = formatDate(fromDate);
      const apiVersion = getApiVersionByDate(formattedFromDate);
      const response = await axiosInstance.get(`/${apiVersion}users/gpr`, {
        params: {
          FromDate: formatDate(fromDate),
          ThruDate: formatDate(toDate),
          store_id: selectedPharmacies.join(","),
          take: 1000000,      // large number to fetch all records

        },
      });

      const allData = response.data;
      setFullData(allData); // store full data

      // Set initial page
      const start = (pagination.current - 1) * pagination.pageSize;
      const end = start + pagination.pageSize;
      setData(allData.slice(start, end));

      // Total entries
      setPagination({
        ...pagination,
        total: allData.length,
      });
    } catch (error) {
      message.error("Failed to fetch data");
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = (newPagination, filters, sorter) => {
    const isSorting = sorter?.order;
    const isPagination = newPagination.current !== pagination.current || newPagination.pageSize !== pagination.pageSize;

    let updatedData = [...fullData];

    if (isSorting) {
      updatedData.sort((a, b) => {
        const aVal = parseFloat(a["GPR Effect"] || 0);
        const bVal = parseFloat(b["GPR Effect"] || 0);
        return sorter.order === "ascend"
          ? aVal - bVal
          : bVal - aVal;
      });
    }

    const start = (newPagination.current - 1) * newPagination.pageSize;
    const end = start + newPagination.pageSize;
    const paginatedData = updatedData.slice(start, end);

    setData(paginatedData);
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
      total: updatedData.length,
    });
  };

  const updatePharmacies = (value) => {
    setSelectedPharmacies(value);
  };

  const handleRefresh = () => {
    fetchData(pagination);
  };

 
  useEffect(() => {
    if (fromDate && toDate && selectedPharmacies?.length > 0) {
      fetchData();
    }
  }, [fromDate, toDate, selectedPharmacies]);

  const handleExport = async () => {
    setDownLoading(true)
    try {
      const formattedFromDate = formatDate(fromDate);
      const apiVersion = getApiVersionByDate(formattedFromDate);
      const response = await axiosInstance.get(`/${apiVersion}users/gpr`, {
        params: {
          FromDate: formatDate(fromDate),
          ThruDate: formatDate(toDate),
          store_id: selectedPharmacies.join(","),
          take: 1000000,
          skip: 0,           // start from beginning
        },
      });
      setDownLoading(false)

      const exportData = response.data;
       const uniqueData = exportData?.filter(
      (item, index, self) =>
        index === self.findIndex((t) => t?.trans_id === item?.trans_id)
    );
      const headers = [
        "Trans ID",
        "Reporting Period",
        "Account Number",
        "Account Name",
        "GCN",
        "NDC",
        "NDC Description",
        "Purchase Quantity",
        "Purchase Amount",
        "Dispense Quantity",
        "Dispense Amount",
        "Estimated Leakage",
        "GPR Effect",
        "Price Type"
      ];

      const rows = uniqueData.map((item) => [
        item?.trans_id,
        item?.ReportingPeriod,
        item?.AccountNumber,
        item?.AccountName,
        item?.GCN,
        item?.NDC,
        item?.["NDC Description"],
        item?.PurchaseQuantity,
        // item?.PurchaseAmount,
        `$ ${item.PurchaseAmount}`,
        item?.DispenseQuantity,
        // item?.DispenseAmount,
        `$ ${item.DispenseAmount}`,
        item?.EstimatedLeakage,
        item?.["GPR Effect"],         // assuming this is the correct key
        item?.PriceType,
      ]);

      // Combine headers and data
      const worksheetData = [headers, ...rows];

      // Create worksheet and workbook
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Leakage Report");

      // Export the Excel file
      XLSX.writeFile(workbook, "leakage_report.xlsx");
    } catch (error) {
      message.error("Failed to export data");
      console.error("Export error:", error);
    } finally {
      setLoading(false);
      setDownLoading()
    }
  };

  const getDisplayPharmacy = (account) => {
  const isGoodUser = userInfo?.user_roles_id === 5;

  if (isGoodUser && account?.acct_id === 96167) {
    return {
       ...account,
      displayName: "ABC Pharmacy",
      displayId: "123456",
    };
  }
  return {
    ...account,
    displayId: account.acct_id,
    displayName: account.name || account.label,
  };
};
  return (
    <>
      <HeaderCompo initialColor={'#000833'} />

      <div className="p-6" style={{ padding: "16px 16px 0 16px" }}>
        <div className="mb-6">
          <h1 className="text-2xl font-bold mb-4">Leakage Data</h1>
          <div className="flex flex-col md:flex-row md:justify-between items-start md:items-center gap-4 mb-4">
            <div className="flex flex-col sm:flex-row sm:flex-wrap gap-4 w-full md:w-auto">
              {/* <Space size="middle"> */}
              <Select
                mode="multiple"
                value={selectedPharmacies}
                onChange={updatePharmacies}
                className="w-full md:w-[400px]"
                style={{
                  // width: "400px",
                  border: "1px solid #d9d9d9",
                  "border-radius": "6px",
                }}
                placeholder="Select pharmacies"
                options={userAccounts.map((account) => {
                  // label: account.name || account.label,
                  // value: account.acct_id || account.acct_id,
                  // key: account.acct_id,
                  const modified = getDisplayPharmacy(account);
                  return {
                    label: `${modified.displayName} (${modified.displayId || account.acct_id})`,
                    value: account.acct_id, 
                    key: account.acct_id,
                    displayId: modified.displayId,    
                  };
                })}
                showSearch
                // filterOption={(input, option) =>{
                //   // (option?.label ?? "")
                //   //   .toLowerCase()
                //   //   .includes(input.toLowerCase()) || (option?.value ?? "")
                //   //   .toLowerCase()
                //   //   .includes(input.toLowerCase())
                //   const label = (option?.label ?? "").toString().toLowerCase();
                //    const value = (option?.value ?? "").toString().toLowerCase();
                //    return (
                //      label.includes(input.toLowerCase()) ||
                //      value.includes(input.toLowerCase())
                //    );
                // }}
                filterOption={(input, option) => {
                const search = input.toLowerCase();
                const label = (option?.label ?? "").toString().toLowerCase();
                const value = (option?.value ?? "").toString().toLowerCase();
                const displayId = (option?.displayId ?? "").toString().toLowerCase();
                return (
                  label.includes(search) ||
                  displayId.includes(search) ||
                  value.includes(search)        
                );
              }}
                maxTagCount={3}
              />
            </div>

            <div className="flex md:m-0 w-full">

              <div className="flex gap-1 w-full md:justify-center align-middle justify-start mr-4">
                <span className="font-medium">From</span>
                <DatePicker
                  placeholder="From Date"
                  value={fromDate ? dayjs.utc(fromDate) : null}
                  onChange={(date) => {
                    if (date) {
                      const utcDate = new Date(Date.UTC(date.year(), date.month(), date.date(), 0, 0, 0, 0));
                      setFromDate(utcDate);
                    }
                    // if (date) {
                    //   const jsDate = new Date(date.toDate());
                    //   jsDate.setHours(0, 0, 0, 0);
                    //   setFromDate(jsDate);
                    // }
                  }}
                  format="MM-DD-YYYY"
                  className="w-full"
                />
              </div>
              <div className="flex flex-row w-full gap-1 justify-center align-middle">
                <span className="font-medium text-gray-600">To</span>

                <DatePicker
                  placeholder="To Date"
                  value={toDate ? dayjs.utc(toDate) : null}
                  onChange={(date) => {
                    if (date) {
                      const utcDate = new Date(Date.UTC(date.year(), date.month(), date.date(), 23, 59, 59, 999));
                      setToDate(utcDate);
                    }
                    // if (date) {
                    //   const jsDate = new Date(date.toDate());
                    //   jsDate.setHours(23, 59, 59, 999);
                    //   setToDate(jsDate);
                    // }
                  }}
                  format="MM-DD-YYYY"
                  className="w-full "
                />
              </div>
              {/* </Space> */}
            </div>
            {/* <Space> */}
            <div className="flex flex-col sm:flex-row gap-2 w-full  md:w-auto">
              <div className="w-full md:w-[200px]">
                <Input
                  placeholder="Search..."
                  prefix={<SearchOutlined />}
                  onChange={(e) => setSearchText(e.target.value)}
                  style={{ border: "1px solid var(--Primary-Dark-Blue, #000833)" }}
                />
              </div>
              <div className="gap-2 flex flex-row md:justify-between justify-start w-full md:w-auto">

                <Button
                  icon={<ReloadOutlined />}
                  onClick={() => fetchData(pagination)}
                  className=" w-full md:w-[100px]"
                >
                  Refresh
                </Button>
                <Button
                  type="primary"
                  icon={<DownloadOutlined />}
                  onClick={() => handleExport()}
                  className=" w-full md:w-[100px]"
                  loading={isDownloading}
                >
                  Export
                </Button>
              </div>
            </div>
            {/* </Space> */}
          </div>
        </div>

        <Table
          columns={columns}
          dataSource={data}
          pagination={pagination}
          onChange={handleTableChange}
          loading={loading}
          scroll={{ x: "max-content" }}
          rowKey="trans_id"
          size="middle"
          className="custom-table user-tbl"
          defaultSortOrder='ascend'
        />
         {/* {userInfo?.email !== "anuja@grapetech.ae" && !chatBoxOpen && (
                <div className="chat-button-new" onClick={() => setChatOpen(true)}>
                  💬 Let’s Chat
                </div>
              )} */}
              {
                userInfo?.user_roles_id === 5 && (
               <div className="fixed bottom-12 right-6 flex flex-col items-end group z-50">
        
                  <div className="flex flex-col gap-3 mb-3 opacity-0 translate-y-2 pointer-events-none transition-all duration-300 group-hover:opacity-100 group-hover:translate-y-0 group-hover:pointer-events-auto"> 
                    {/* <Tooltip title="Subscribe" placement="left">
                      <div
                        onClick={() => {
                          setIsSupportActive(true)
                          setChatOpen(true)
                        }}
                        className="w-12 h-12 rounded-full bg-blue-600 text-white flex items-center justify-center shadow-lg cursor-pointer hover:scale-110 transition-transform duration-200"
                      >
                        <Headphones size={20} />
                      </div>
                    </Tooltip> */}
                    <Tooltip title="Support" placement="left">
                      <div
                        onClick={() => {
                          setChatOpen(true)
                        }}
                        className="w-12 h-12 rounded-full bg-emerald-500 text-white flex items-center justify-center shadow-lg cursor-pointer hover:scale-110 transition-transform duration-200"
                      >
                        <MessageCircle size={20} />
                      </div>
                    </Tooltip>
                  </div>
                  {userInfo?.email !== "anuja@grapetech.ae" && !chatBoxOpen && (
                    <div className="bg-[#000437] text-white px-5 py-3 rounded-full font-semibold shadow-xl cursor-pointer hover:scale-105 transition-all duration-300">
                      💬 Let’s Chat
                    </div>
                  )}
                </div>
                )
              }
              <Chat 
                open={chatBoxOpen}
                setOpen={setChatOpen}
                isSupport={false}
                allAcounts = {userAccounts}
              />
      </div>
    </>
  );
};

export default DataTableGpr;


// Update fetchData to handle empty selectedPharmacies
  // const fetchData = async (params = {}) => {
  //   const currentPage = params.current || pagination.current;
  //     const pageSize = params.pageSize || pagination.pageSize;

  //   setLoading(true);
  //   try {
  //     const response = await axiosInstance.get(`/users/gpr`, {
  //       params: {
  //         FromDate: fromDate.toISOString().split("T")[0], // → "2024-10-01"
  //         ThruDate: toDate.toISOString().split("T")[0],   // → "2024-10-31"
  //         store_id: selectedPharmacies.join(","),
  //         // page: params.current || pagination.current,
  //         // pageSize: params.pageSize || pagination.pageSize,
  //         // sortField: params.sortField,
  //         // sortOrder: params.sortOrder,
  //         skip: (currentPage - 1) * pageSize,
  //         take: pageSize,
  //       },
  //       // headers: {
  //       //   Authorization: `Bearer ${token}`,
  //       // },
  //     });
  //      const sorted = [...response.data].sort((a, b) =>
  //   parseFloat(a["GPR Effect"] || 0) - parseFloat(b["GPR Effect"] || 0)
  // );
  // console.log(response,"response in adaaaa")
  //     setData(sorted);
  //     // setPagination({
  //     //   ...pagination,
  //     //   total: response.data,
  //     // });
  //     setPagination({
  //       current: currentPage,
  //       pageSize: pageSize,
  //       total:
  //         sorted.length < pageSize
  //           ? (currentPage - 1) * pageSize + sorted.length
  //           : currentPage * pageSize + 1,
  //     });
  //   } catch (error) {
  //     message.error("Failed to fetch data");
  //     console.error("Error:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
